(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import { getProjectId } from "jcb-token-kit";
import "./NavMenu.css";

var MenuTrigger = function MenuTrigger(props) {
  var city = props.city,
      jsjb = props.jsjb,
      _props$styles = props.styles,
      styles = _props$styles === undefined ? {} : _props$styles,
      _props$collapsed = props.collapsed,
      collapsed = _props$collapsed === undefined ? false : _props$collapsed,
      _props$onToggle = props.onToggle,
      onToggle = _props$onToggle === undefined ? function () {} : _props$onToggle,
      _props$B = props.B41,
      B41 = _props$B === undefined ? {} : _props$B;

  var jsjbProject = process.env.REACT_APP_JCB_ENV === "dev" ? getProjectId() === "1280" || getProjectId() === "838" : getProjectId() === "1044" || getProjectId() === "1187";

  var renderContent = function renderContent() {
    if (city) {
      return React.createElement(
        "div",
        {
          onClick: function onClick() {
            if (onToggle) {
              onToggle();
            }
          },
          className: "return-home-btn-cc",
          title: "\u8FD4\u56DE\u9879\u76EE\u5217\u8868",
          styles: styles
        },
        React.createElement(
          "span",
          null,
          "<"
        ),
        React.createElement(
          "span",
          { style: { marginLeft: "7px" } },
          "\u8FD4\u56DE"
        )
      );
    }
    if (jsjb) {
      return React.createElement(
        "div",
        {
          onClick: function onClick() {
            if (onToggle) {
              onToggle(jsjbProject);
            }
          },
          className: "return-home-btn-cc",
          title: "\u8FD4\u56DE\u5DE5\u4F5C\u53F0",
          styles: styles
        },
        React.createElement(
          "span",
          null,
          "<"
        ),
        React.createElement(
          "span",
          { style: { marginLeft: "7px" } },
          "\u8FD4\u56DE"
        )
      );
    }
    // 精细化管理项目
    if (document.location.hostname === "jc.smartcity.survey.work" && document.location.hostname === "test.jc.daxing.wenming.city") {
      return null;
    }
    return React.createElement(
      "div",
      {
        onClick: function onClick() {
          onToggle(!collapsed);
        },
        className: "return-home-btn",
        title: B41 ? B41.value : "返回调研工厂",
        styles: styles
      },
      collapsed ? React.createElement(
        "span",
        null,
        ">"
      ) : React.createElement(
        "span",
        null,
        "<"
      )
    );
  };
  return React.createElement(
    "div",
    null,
    renderContent()
  );
};

var _default = MenuTrigger;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MenuTrigger, "MenuTrigger", "src/components/MenuTrigger.js");
  reactHotLoader.register(_default, "default", "src/components/MenuTrigger.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();